import { createContext, useContext, useEffect, useState } from 'react';
import { loadSpace } from '@usersnap/browser';
import type { SpaceApi } from '@usersnap/browser';

// Use this key for configuring integrations or plugins.
export const USERSNAP_SPACE_API_KEY = 'dd1d7e61-e6e3-48dc-927c-544d193c923c';

export const UsersnapContext = createContext<SpaceApi | null>(null);

export const UsersnapProvider = ({ children }: { children: React.ReactNode }) => {
    const [usersnapApi, setUsersnapApi] = useState<SpaceApi | null>(null);

    useEffect(() => {
        if (USERSNAP_SPACE_API_KEY) {
            loadSpace(USERSNAP_SPACE_API_KEY).then((api) => {
                api.init();
                setUsersnapApi(api);
            });
        }
    }, []);

    return <UsersnapContext.Provider value={usersnapApi}>{children}</UsersnapContext.Provider>;
};

export function useUsersnapApi() {
    return useContext(UsersnapContext);
}
